import React from 'react';

import CardsTable from './CardsTable';
import NavBar     from 'NavBar';


function CardsInfoPage() {

  return (
    <>
      <NavBar/>
      <CardsTable/>
    </>
  );
}

export default CardsInfoPage;